import {SurveyQuestionType} from "crqlar-react-common/dist/models/survey/survey.model";
import React from "react";
import ChecklistQuestion from "./questions/ChecklistQuestion";
import ChoiceQuestion from "./questions/ChoiceQuestion";
import DateQuestion from "./questions/DateQuestion";
import DropdownQuestion from "./questions/DropdownQuestion";
import LegalQuestion from "./questions/LegalQuestion";
import NumberQuestion from "./questions/NumberQuestion";
import {RunnerQuestionProps} from "./questions/runnerQuestion.types";
import ScoreQuestion from "./questions/ScoreQuestion";
import StarsQuestion from "./questions/StarsQuestion";
import TextQuestion from "./questions/TextQuestion";
import UploadQuestion from "./questions/UploadQuestion";
import YesNoQuestion from "./questions/YesNoQuestion";

const componentForType = (type: SurveyQuestionType | undefined) => {
    switch (type) {
        case SurveyQuestionType.GENERIC_SCORE:
            return ScoreQuestion;
        case SurveyQuestionType.GENERIC_STARS:
            return StarsQuestion;
        case SurveyQuestionType.MULTIPLE_CHOICE:
        case SurveyQuestionType.PICTURE_CHOICE:
            return ChoiceQuestion;
        case SurveyQuestionType.DROPDOWN:
            return DropdownQuestion;
        case SurveyQuestionType.CHECKLIST:
            return ChecklistQuestion;
        case SurveyQuestionType.YES_NO:
            return YesNoQuestion;
        case SurveyQuestionType.SHORT_TEXT:
        case SurveyQuestionType.LONG_TEXT:
            return TextQuestion;
        case SurveyQuestionType.DATE:
            return DateQuestion;
        case SurveyQuestionType.NUMBER:
            return NumberQuestion;
        case SurveyQuestionType.LEGAL:
            return LegalQuestion;
        case SurveyQuestionType.UPLOAD_MEDIA:
            return UploadQuestion;
        // Screens are no question: the staff runner and the guest page draw them themselves.
        case SurveyQuestionType.WELCOME:
        case SurveyQuestionType.END_SCREEN:
            return undefined;
        case undefined:
            return undefined;
        default: {
            // A new enum member fails the typecheck here; a type from a newer API still renders nothing.
            const unhandled: never = type;
            return undefined;
        }
    }
};

function SurveyRunnerQuestion(props: RunnerQuestionProps) {
    const Component = componentForType(props.question.type);
    if (!Component) return null;

    return <Component {...props}/>;
}

export default SurveyRunnerQuestion;
